<template>
  <vue-drag-resize
    :h="height"
    :w="width"
    :x="calculateX"
    :y="calculateY"
    :isActive="isActive"
    :isResizable="true"
    :parentLimitation="true"
    :parentH="parentHeight"
    :parentW="parentWidth"
    v-on:dragging="resize"
    v-on:resizing="resize"
    v-on:activated="activateElement"
    v-on:deactivated="deactivateElement"
  >
    <div class="slot-container">
      <slot></slot>
    </div>
  </vue-drag-resize>
</template>

<script lang="ts">
import VueDragResize from "vue-drag-resize";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    VueDragResize
  }
})
export default class AppDraggableAndResizableWrapper extends Vue {
  private isActive: boolean = false;
  private parentWidth: number = 0;
  private parentHeight: number = 0;
  private width: number = 400;
  private height: number = 450;
  private top: number = 0;
  private left: number = 0;

  get calculateX(): number {
    return Math.round(this.parentWidth / 1.7);
  }

  get calculateY(): number {
    return 250; // this.parentHeight - this.height;
  }

  activateElement(): void {
    this.isActive = true;
  }

  deactivateElement(): void {
    this.isActive = false;
  }

  private resize(newRect: any): void {
    this.width = newRect.width;
    this.height = newRect.height;
    this.top = newRect.top;
    this.left = newRect.left;
  }

  calculateParentSize(): void {
    this.parentWidth = window.innerWidth;
    this.parentHeight = window.innerHeight;
  }

  created() {
    window.addEventListener("resize", this.calculateParentSize);

    this.calculateParentSize();
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.calculateParentSize);
  }
}
</script>

<style>
.vdr {
  position: fixed !important;
  z-index: 2 !important;
}

.vdr.active:before {
  outline: none !important;
}

.slot-container {
  height: 100%;
  overflow: hidden;
}
</style>
